import React from 'react'
import { BrowserRouter } from "react-router-dom";
import Nav from './nav/Nav';
import NewAbout from './screens/NewAbout'
import NewEngineeringResponse from './screens/NewEngineeringResponse';

const App = () => {
  return (

    <BrowserRouter>
      <Nav />
    </BrowserRouter>
  )
}

export default App